import thunk from 'redux-thunk';
import logger from "./logger.js";
import crashReporter from "./crashReporter.js";
export default [logger, crashReporter, thunk];
//# sourceMappingURL=index.js.map